import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import Banner from '../components/banner'
import ImgModal from '../components/imgmodal'

class IndexPage extends Component
{
  constructor(props)
  {
    super(props)
    this.screenshotLookup = {}; 
    for(var screenshotfile of this.props.data.allFile.edges)
    {
      this.screenshotLookup[screenshotfile.node.relativePath] = screenshotfile.node.childImageSharp
    }

  }

  render()
  {
    const {data} = this.props
    return(
    <div>
      <Banner />
      <section id="intro" className="wrapper style1">
        <div className="container">
          <h2>
            <span>
              A grand strategy game where you play a national spirit and lead your
              country to glory.
            </span>
          </h2>
          <footer>
            <p>
              Manage war, diplomacy, technology, economy, internal politics, and
              more to secure your fame!
            </p>
          </footer>
        </div>
      </section>

      <section id="main" className="wrapper style2">
        <div className="container">
          <section className="features">
            <header>
              <h2>Haunt the halls of history!</h2>
              <p>
                Discover how <b>you</b> would use unearthly powers to dominate the
                world!
              </p>
            </header>
            <div className="row">
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot1"/>                
                  <h3>Govern Wisely</h3>
                  <p>Pick government policies, but consider the opposition.</p>
                </section>
              </div>
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot3"/>
                  <h3>Recruit the Best</h3>
                  <p>After all, you don't need any more idiots by your side.</p>
                </section>
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot4"/>
                  <h3>Respond to Current Events</h3>
                  <p>
                    When unexpected issues arise, you must weigh the political
                    consequences and take sides.
                  </p>
                </section>
              </div>
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot8"/>
                  <h3>Make Nice with your Neighbors</h3>
                  <p>
                    Well-thought diplomacy can settle disputes and increase your
                    security. When that fails, there's always the stick.
                  </p>
                </section>
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot2"/>
                  <h3>Keep Your Eye on the Ball</h3>
                  <p>
                    The world is a busy place. Watch out for your enemies and your
                    "friends" alike.
                  </p>
                </section>
              </div>
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot9"/>
                  <h3>Play your Best Hand</h3>
                  <p>
                    Rulers provide bonuses and penalties throughout your empire.
                    Make the best use of your position!
                  </p>
                </section>
              </div>
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot5"/>
                  <h3>Navigate Byzantine Politics</h3>
                  <p>
                    Institutions have their own agendas and might not care for
                    yours.
                  </p>
                </section>
              </div>
              <div className="col-6 col-6-narrow col-12-mobile">
                <section>
                  <ImgModal screenshotLookup={this.screenshotLookup} value="screenshot10"/>
                  <h3>Improve Your Lands</h3>
                  <p>
                    Build up your territory to cement your hold on power. 
                  </p>
                </section>
              </div>
            </div>
          </section>
          <span className="logo" data-target="#trailerModal" />
          <section className="wrapper">
            <header>
              <h2>Features</h2>
            </header>
            <div className="row">
              <div className="col-12 col-12-narrow col-12-mobile">
                <ul>
                  <li>
                    <strong>Build a nation</strong> in a world teeming with
                    nomadic tribes, bustling cities, thrifty merchants, brilliant
                    scientists, and upstart kings.
                  </li>
                  <li>
                    <strong>Explore a beautiful 3D spherical globe</strong> with
                    over 5000 territories, suitable for the most maniacal of
                    conquerors.
                  </li>
                  <li>
                    <strong>Rewrite history</strong> for one of more than one
                    thousand countries over two centuries.
                  </li>
                  <li>
                    <strong>Manage internal politics</strong> and navigate
                    relations with internal factions as well as current issues.
                  </li>
                  <li>
                    <strong>Develop your economy</strong> and found cities,
                    develop trade routes, and expand infrastructure.
                  </li>
                  <li>
                    <strong>Conduct diplomacy</strong> to improve your security
                    and advance your goals.
                  </li>
                  <li>
                    <strong>Advance technology</strong> to increase your strength.
                  </li>
                  <li>
                    <strong>Experience an original soundtrack </strong> over one
                    hour long.
                  </li>
                  <li>
                    <strong>Recruit talented people</strong> to further your
                    civilization.
                  </li>
                  <li>
                    <strong>Unleash armies and navies</strong> to flatten your
                    foes.
                </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  )
  }
}

export default IndexPage

export const fileImageQuery = graphql`
  query fileImageQuery {
    allFile(sort: {fields: [relativePath], order: ASC})
    {
      edges {
        node {
          relativePath
          childImageSharp
          {
                sizes(maxWidth: 1920 ) {
                  ...GatsbyImageSharpSizes
                }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js